import React from 'react';
import {SwitchInput} from "../../Form";
import {inject, observer} from "mobx-react/index";

@inject('ticketStore', 'userStore', 'ticketStatusStore', 'ticketReasonStore', 'ticketActionStore', 'workOrderStatusStore', 'priorityStore', 'maintenanceTypeStore')
@observer
export default class StationMaintenance extends React.Component {

  state = {
    view_archived: false
  };

  componentWillMount() {
    const {ticketStore, userStore, ticketStatusStore, ticketReasonStore, ticketActionStore, workOrderStatusStore, priorityStore, maintenanceTypeStore} = this.props;
    if(ticketStore.items.length === 0) ticketStore.fetchItems();
    if(userStore.items.length === 0) userStore.fetchItems();
    if(ticketStatusStore.items.length === 0) ticketStatusStore.fetchItems();
    if(ticketReasonStore.items.length === 0) ticketReasonStore.fetchItems();
    if(ticketActionStore.items.length === 0) ticketActionStore.fetchItems();
    if(workOrderStatusStore.items.length === 0) workOrderStatusStore.fetchItems();
    if(priorityStore.items.length === 0) priorityStore.fetchItems();
    if(maintenanceTypeStore.items.length === 0) maintenanceTypeStore.fetchItems();
  }


  render() {
    return (
      <div>
        <div className='flex flex-end'>
          <SwitchInput label='View Archived' onChange={() => this.setState({view_archived: !this.state.view_archived})}/>
        </div>
        {this.props.children ? React.cloneElement(this.props.children, {...this.state}) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Station/Maintenance/StationMaintenance.js